import { render } from "./ModuliRrOverview.vue?vue&type=template&id=25afbed7&scoped=true"
import script from "./ModuliRrOverview.vue?vue&type=script&lang=js"
export * from "./ModuliRrOverview.vue?vue&type=script&lang=js"

import "./ModuliRrOverview.vue?vue&type=style&index=0&id=25afbed7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25afbed7"]])

export default __exports__